export const SET_VALUE = (state, [key, value]) => {
  state[key] = value
}

// ------------
// FORM
// ------------
export const SET_FORM_VALUE = (state, [key, value]) => {
  state.form[key] = value
}

export const SET_PUSH_PRICES = (state, payload) => {
  state.form.prices.push(payload)
}

export const UPDATE_PRICE = (state, [value, index]) => {
  state.form.prices[index] = value
}

export const REMOVE_PRICE = (state, index) => {
  state.form.prices.splice(index, 1)
}

export const SET_CATEGORY_VALUE = (state, [key, value]) => {
  state.form[key].value = value
}

export function SET_CATEGORY_OPTIONS (state, [key, payload]) {
  state.form[key].rawOptions = payload
}

export const SET_FORM_MULTIPLE = (state, payload) => {
  Object.keys(state.formDefault).forEach(item => {
    state.form[item] = payload[item]
  })
}

export const RESET_FORM = (state, payload) => {
  state.form = JSON.parse(JSON.stringify(state.formDefault))
}

// IMAGES
export const SET_IMAGES = (state, payload) => {
  state.form.images = payload.map(() => {
    return {}
  })

  setTimeout(() => {
    state.form.images.forEach((item, index) => {
      state.form.images[index] = payload[index]
    })
  }, 500)
}

export const PUSH_IMAGES = (state, payload) => {
  state.form.images.push(payload)
}

export const UPDATE_IMAGE = (state, [value, index]) => {
  state.form.images[index] = value
}

export const REMOVE_IMAGE = (state, index) => {
  state.form.images.splice(index, 1)
}
